import React, { useEffect } from 'react';

type Options = {
  threshold?: number;
  observeOnce?: boolean;
};

const useElementInViewport = (
  elementRef: React.RefObject<HTMLElement>,
  { threshold = 0.5, observeOnce = false }: Options
) => {
  const [isVisible, setIsVisible] = React.useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
        if (observeOnce && entry.isIntersecting) {
          observer.disconnect();
        }
      },
      {
        threshold,
      }
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => {
      if (elementRef.current) {
        observer.unobserve(elementRef.current);
      }
    };
  }, [elementRef]);

  return isVisible;
};

export default useElementInViewport;
